<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
    mounted(){
        // this.$router.push({name:'ks-index'})
    }
}
</script>

<style>

</style>